import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'camino-react'

class TicketCreateFormSectionsServiceType extends React.Component {
  setTicketTypeAndSection = (typeId) => {
    const { setFieldValue, setNextModalSection, userManagementCategoryId } = this.props

    setFieldValue('ticket_type_id', 2)

    if (typeId === 8) {
      setFieldValue('service_category_id', userManagementCategoryId)
      setNextModalSection('UserManagement')
    } else if (typeId === 2) {
      setFieldValue('service_category_id', null)
      setNextModalSection('Service')
    }
  }

  render () {
    const { serviceCategoryId, userManagementCategoryId } = this.props
    const { setTicketTypeAndSection } = this

    return (
      <Fragment>
        <label>
          What service does this relate to?
        </label>
        <br />

        <Row classExtra="row--bottom-spaced">
          <Col width={12}>
            <div className="flex--grow" style={{ width: '500px' }}>
              <label htmlFor="ticket_ticket_type_8" className="label label--half-margin" style={{ userSelect: 'none' }}>
                <input
                  type="radio"
                  onChange={(event) => { setTicketTypeAndSection(8) }}
                  checked={serviceCategoryId === userManagementCategoryId}
                  id="ticket_ticket_type_8"
                />
                <span />
                User Management
              </label>
            </div>
          </Col>

          <Col width={12}>
            <div className="flex--grow" style={{ width: '500px' }}>
              <label htmlFor="ticket_ticket_type_2" className="label label--half-margin" style={{ userSelect: 'none' }}>
                <input
                  type="radio"
                  onChange={(event) => { setTicketTypeAndSection(2) }}
                  checked={serviceCategoryId !== userManagementCategoryId}
                  id="ticket_ticket_type_2"
                />
                <span />
                Other
              </label>
            </div>
          </Col>
        </Row>
      </Fragment>
    )
  }
}

TicketCreateFormSectionsServiceType.propTypes = {
  serviceCategoryId: PropTypes.number.isRequired,
  userManagementCategoryId: PropTypes.number.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setNextModalSection: PropTypes.func.isRequired
}

export default TicketCreateFormSectionsServiceType
